import { css } from "styled-components";

export const defaultTransition = css`
    transition: 400ms ease-in;
`